// src/utils/auth.js

const USERS_KEY = "users";
const ADMIN_EMAILS = ["monteroesteban@hotmail.com"];

export function registerUser(email, password) {
  const users = JSON.parse(localStorage.getItem(USERS_KEY)) || [];
  if (users.find(u => u.email === email)) {
    return { success: false, message: "El correo ya está registrado." };
  }
  const newUser = { email, password, role: "user", username: "", avatar: "🎬" };
  users.push(newUser);
  localStorage.setItem(USERS_KEY, JSON.stringify(users));
  localStorage.setItem(`favorites_${email}`, JSON.stringify([]));
  localStorage.setItem("currentUser", JSON.stringify({ email, role: newUser.role, username: "", avatar: "🎬" }));
  return { success: true, user: { email, role: newUser.role, username: "", avatar: "🎬" } };
}

export function loginUser(email, password) {
  const users = JSON.parse(localStorage.getItem(USERS_KEY)) || [];
  const found = users.find(u => u.email === email && u.password === password);
  if (!found) return { success: false, message: "Credenciales inválidas." };
  const role = ADMIN_EMAILS.includes(email) ? "admin" : found.role;
  const session = { email, role, username: found.username || "", avatar: found.avatar || "🎬" };
  localStorage.setItem("currentUser", JSON.stringify(session));
  return { success: true, user: session };
}

export function updateProfile(email, { username, avatar }) {
  const users = JSON.parse(localStorage.getItem(USERS_KEY)) || [];
  const idx = users.findIndex(u => u.email === email);
  if (idx === -1) return false;
  if (username !== undefined) users[idx].username = username;
  if (avatar   !== undefined) users[idx].avatar   = avatar;
  localStorage.setItem(USERS_KEY, JSON.stringify(users));
  // Update current session
  const session = JSON.parse(localStorage.getItem("currentUser")) || {};
  if (username !== undefined) session.username = username;
  if (avatar   !== undefined) session.avatar   = avatar;
  localStorage.setItem("currentUser", JSON.stringify(session));
  return true;
}

export function changePassword(email, currentPassword, newPassword) {
  const users = JSON.parse(localStorage.getItem(USERS_KEY)) || [];
  const idx = users.findIndex(u => u.email === email && u.password === currentPassword);
  if (idx === -1) return false;
  users[idx].password = newPassword;
  localStorage.setItem(USERS_KEY, JSON.stringify(users));
  return true;
}

export function getCurrentUser() {
  const raw = localStorage.getItem("currentUser");
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function logoutUser() {
  localStorage.removeItem("currentUser");
}

export function getFavorites(email) {
  return JSON.parse(localStorage.getItem(`favorites_${email}`)) || [];
}

export function toggleFavorite(email, seriesId) {
  let favs = JSON.parse(localStorage.getItem(`favorites_${email}`)) || [];
  if (favs.includes(seriesId)) {
    favs = favs.filter(id => id !== seriesId);
  } else {
    favs.push(seriesId);
  }
  localStorage.setItem(`favorites_${email}`, JSON.stringify(favs));
  return favs;
}

export function isFavorite(email, seriesId) {
  const favs = JSON.parse(localStorage.getItem(`favorites_${email}`)) || [];
  return favs.includes(seriesId);
}
